import { Component, OnInit} from '@angular/core';






import { ManualInputService } from '../manual-input.service';


@Component({
    selector: 'app-manualdatasettings',
    templateUrl: './manualdatasettings.component.html',
    styleUrls: ['./manualdatasettings.component.scss'],
    standalone: false
})
export class ManualdatasettingsComponent implements OnInit {

  constructor(private ManualInptSvc: ManualInputService) { }

  ngOnInit() {
    this.getschemaddl();
  }
  schemadata: any = [];
  tabledata: any = [];
  singletabledet: any = [];
  selectedschema: string;
  selectedtable: string;

  private getschemaddl() {
    this.ManualInptSvc.GetSchemaLst().subscribe
      (
        resp => {
          for (let i = 0; i < resp.schemaNameList.length; i++) {
            this.schemadata[i] = resp.schemaNameList[i].schema_name;
          }
        },
        err => {
          console.log(err);
        }
      );
  }
  onSchemaddlValueChanged(e) {
    this.selectedschema = e.value;
    this.tabledata = [];
    this.GetTablesList(e.value);
  }

  onTableddlValueChanged(e) {
    this.selectedtable = e.value;
    this.GetTablesList(e.value);
  }

  public GetTablesList(value): void {
    this.ManualInptSvc.GetTableLst(value).subscribe
      (
        resp => {
          for (let i = 0; i < resp.tableNamesList.length; i++) {
            this.tabledata[i] = resp.tableNamesList[i].table_name;
          }
        },
        err => {
          console.log(err);
        }
      );
  }

  public SearchData(): void {
    this.ManualInptSvc.GetTableDet(this.selectedschema, this.selectedtable).subscribe
      (
        resp => {
          this.singletabledet = resp.tableStructure;
        },
        err => {
          console.log(err);
        }
      );
  }

}
